import { render, staticRenderFns } from "./Telenology.vue?vue&type=template&id=45575661&scoped=true"
import script from "./Telenology.vue?vue&type=script&lang=js"
export * from "./Telenology.vue?vue&type=script&lang=js"
import style0 from "./Telenology.vue?vue&type=style&index=0&id=45575661&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45575661",
  null
  
)

export default component.exports